import {
  ACORIS_SOCIAL_REGIMES,
  COLLECTIVE_OFFER_RANKS,
  CONTRIBUTION_STRUCTURES,
  EMPLOYEE_CATEGORIES,
} from "utils/constants";

export const NIL_PLACEHOLDER = "—";

export const COLLECTIVE_REGIME_ORDER = [
  ACORIS_SOCIAL_REGIMES.SECURITE_SOCIALE,
  ACORIS_SOCIAL_REGIMES.ALSACE_MOSELLE,
];

export const EMPLOYEE_CATEGORY_ORDER = [
  EMPLOYEE_CATEGORIES.ALL_STAFF,
  EMPLOYEE_CATEGORIES.CADRE,
  EMPLOYEE_CATEGORIES.NON_CADRE,
];

export const CONTRIBUTION_STRUCTURE_ORDER = [
  CONTRIBUTION_STRUCTURES.EMPLOYEE_SPOUSE_CHILD,
  CONTRIBUTION_STRUCTURES.SINGLE_FAMILY,
  CONTRIBUTION_STRUCTURES.SINGLE_DUO_FAMILY,
  CONTRIBUTION_STRUCTURES.FLAT_FAMILY_RATE,
];

export const OPTION_RANKS = [
  COLLECTIVE_OFFER_RANKS.OPTION_1,
  COLLECTIVE_OFFER_RANKS.OPTION_2,
];

export const COMMERCIAL_ADJUSTMENTS = [-10, -5, 0, 5, 10, 15, 20];

export const DEFAULT_COMMERCIAL_ADJUSTMENT = 0;

export const STEP_INDEXES = {
  COMPANY: 0,
  DEMOGRAPHICS: 1,
  OFFER: 2,
  SUMMARY: 3,
  SUBSCRIPTION: 4,
};

export const DEMOGRAPHIC_FIELDS = {
  category: "employeeCategory",
  headcount: "headcount",
  regime: "socialRegime",
  effectiveDate: "effectiveDate",
  averageAge: "averageAge",
  department: "department",
};
